import { Button } from "../../components/ui/Button";

export const WhoCanHireFgts = ({ onGoToRegister, onGoTo }) => (
    <section id="WhoCanHireFgts" className="bg-white py-16 px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">

            {/* Imagem à esquerda */}
            <div className="w-full lg:w-1/2 flex justify-center lg:justify-start">
                <img
                    src="/assets/velho-tablet.png"
                    alt="Pessoa usando celular"
                    className="bg-[#FA6300] rounded-full max-w-md w-full h-auto transform scale-x-[-1]"
                />
            </div>

            {/* Conteúdo à direita */}
            <div className="w-full lg:w-1/2">
                <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                    Sem consulta ao SPC e Serasa
                </span>

                <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
                    Quem pode contratar?
                </h2>

                <p className="text-gray-600 mb-8">
                    Confira o que é preciso para você antecipar seu Saque-Aniversário FGTS e aproveitar
                </p>

                <ul className="space-y-6 mb-8">
                    {[
                        'Ser maior de 18 anos e ter optado pelo Saque-Aniversário;',
                        'Ter trabalhado de carteira assinada ou possuir saldo FGTS em uma conta;',
                        'Possuir uma conta corrente ou poupança;',
                        'Já ter Autorizado o Banco Bmg a a ter acesso aos valores e dados do seu FGTS;',
                    ].map((text, index) => (
                        <li key={index} className="flex items-start gap-3">
                            <div className="flex-shrink-0 w-6 h-6 border-2 border-orange-500 text-orange-500 rounded-full flex items-center justify-center">
                                <svg
                                    className="w-3 h-3"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <p className="text-gray-800">{text}</p>
                        </li>
                    ))}
                </ul>
                <Button onClick={onGoToRegister} className="">
                    Simular antecipação FGTS
                </Button>
            </div>
        </div>
    </section>
);